import { Colors, Router, Storage } from '@lightningjs/sdk';
import lng from '@lightningjs/core';

let profileInfo;
export default class ChooseAvatar extends lng.Component {
  static _template() {
    return {
      Item: {
        Image: {
          collision: true,
        },
      },
      FocusRing: {},
    };
  }

  _construct() {
    super._construct();
    this.spacing = 0;
  }

  set src(val) {
    this._src = val;
  }

  get src() {
    return this._src;
  }

  get _Image() {
    return this.tag('Item.Image');
  }

  get _FocusRing() {
    return this.tag('FocusRing');
  }

  _focus() {
    this._FocusRing.smooth = { color: Colors('#02AC25').get() };
  }

  _unfocus() {
    this._FocusRing.smooth = { color: Colors('#d6d6d7').get() };
  }

  _handleEnter() {
    profileInfo = Storage.get(this._profileId);
    Storage.set(this._profileId, {
      ...profileInfo,
      profileImage: this._src,
      avatar_id: this._avatarId,
    });
    Router.go(-1);
  }

  set profileId(val) {
    return (this._profileId = val);
  }

  set avatarId(val) {
    return (this._avatarId = val);
  }

  set index(val) {
    this._index = val;
  }

  set rowIndex(val) {
    this._rowIndex = val;
  }

  _enable() {
    this._FocusRing.patch({
      w: this.w + this.spacing,
      h: this.h + this.spacing,
      mount: 0.5,
      x: this.w / 2,
      y: this.h / 2,
      zIndex: 2,

      texture: lng.Tools.getRoundRect(
        this.w + this.spacing,
        this.h + this.spacing,
        this.w / 2,
        5,
        Colors('#d6d6d7').get(),
        false
      ),
    });
    this._Image.patch({
      rtt: true,
      zIndex: 2,
      w: this.w,
      h: this.h,
      texture: {
        type: lng.textures.ImageTexture,
        src: this._src,
        resizeMode: { type: 'cover', w: this.w, h: this.h },
      },
      shader: {
        type: lng.shaders.RoundedRectangle,
        radius: this.w / 2,
      },
    });
  }

  _handleHover() {
    this.fireAncestors('$unselectCurrentIndex');
    this.fireAncestors('$setIndex', { rowIndex: this._rowIndex, index: this._index });
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }

  _handleClick() {
    this._handleEnter();
  }
}
